import type { ReactNode } from "react";

const MOMENTS = ["Community fundraisers", "Giving nights", "Everyday generosity"] as const;

export function PromiseStrip() {
  const items: ReactNode[] = [];
  MOMENTS.forEach((moment, index) => {
    if (index > 0) {
      items.push(<span className="promise__dot" aria-hidden="true" key={`dot-${index}`} />);
    }
    items.push(
      <p className="promise__item" key={moment}>
        {moment}
      </p>,
    );
  });

  return (
    <div className="promise">
      <div className="page promise__row">
        <span className="promise__label">For the moments that bring us together</span>
        {items}
      </div>
    </div>
  );
}
